import { createStoryblok, allowVisualEditor } from "@/storyblok";
import {
  createLandingspageSchema,
  createStorySchema,
} from "@/storyblok/schemas";
import { notFound } from "next/navigation";

const storyblok = createStoryblok();

export default async function getLandingPageStoryOrFail(storySlug: string) {
  let storyResponse;

  try {
    storyResponse = await storyblok.get(
      `cdn/stories/landingspages/${storySlug}`,
      { version: allowVisualEditor() ? "draft" : "published", cv: Date.now() }
    );
  } catch {
    notFound();
  }

  const schema = createStorySchema(createLandingspageSchema());
  const story = schema.parse(storyResponse.data.story);

  return story;
}
